// Copyright ©️ 2026 eVolve MEP, LLC

import type { Label, LabelId } from '@evolvemep/api-ts';
import type { CustomFilterProps } from 'ag-grid-react';

import { WORK_ORDER_LABEL_TYPE_ID } from 'components/Mantine/Labels/constants';
import { customSetFilterParams } from 'helpers/ag-grid/convertAgGridRequest';
import { CustomValueSetFilterComponentWrapped, type SetFilterModal } from 'helpers/ag-grid/CustomSetFilterComponent';
import { useLabels } from 'hooks/typeCacheHooks/useLabels/useLabels';

export const WorkOrdersLabelFilter = (filterProps: CustomFilterProps<Label[], never, SetFilterModal<LabelId>>) => {
  const { labels } = useLabels(WORK_ORDER_LABEL_TYPE_ID);

  return (
    <CustomValueSetFilterComponentWrapped<Label[], Label, LabelId, never>
      {...filterProps}
      {...customSetFilterParams(labels, 'labelId', 'name')}
    />
  );
};
